let rect;
let txtX;
let txtY;
let container;
let button;

// const pinHeight = 44;
// const pinWidth = 31;

function handleMousemove(event) {
    if (
        !container.dataset.active
        || event.target.nodeName !== 'path'
    ) {
        txtX.innerText = 'x: N/A';
        txtY.innerText = 'y: N/A';
        return;
    }

    rect = container.getBoundingClientRect();

    const x = event.offsetX;
    const y = event.offsetY;

    const xPercent = 100 * (x / rect.width);
    const yPercent = 100 * (y / rect.height);

    txtX.innerText = `x: ${xPercent.toFixed(2)}`;
    txtY.innerText = `y: ${yPercent.toFixed(2)}`;
}

function disablePins() {
    container.classList.toggle('pins-disabled');
    button.classList.toggle('is-disabled');

    if (container.classList.contains('pins-disabled')) {
        button.innerText = 'Enable Pins';
    } else {
        button.innerText = 'Disable Pins';
    }
}

export default function PinLocator(el) {
    const map = el.closest('#map');
    container = map.querySelector('.map__container');
    button = el.querySelector('button');

    txtX = el.querySelector('[data-x]');
    txtY = el.querySelector('[data-y]');

    container.addEventListener('mousemove', handleMousemove);
    button.addEventListener('click', disablePins);
}
